import { useLocation } from 'react-router';
import { paths } from '@/constants';
import { useProjectId } from '@/hooks';
import { ImportScriptButton } from './ImportScriptButton';
import { ImportScriptModal } from './ImportScriptModal';

/** The sidebar's import/export buttons act on the open project, so they hide
 *  without one and on the account-level pages. */
export const useScriptTransferVisible = () => {
    const project_id = useProjectId();
    const location = useLocation();

    const isAccountPage = [
        paths.profile.index,
        paths.company.index,
        paths.company.projects,
        paths.employees.index,
        paths.employees.invite,
    ].some(p => p === location.pathname);

    return !!project_id && !isAccountPage;
};

export const ImportScript = () =>
    useScriptTransferVisible() ? (
        <>
            <ImportScriptButton />
            <ImportScriptModal />
        </>
    ) : null;
